import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appAccordionElementHeader]'
})
export class AccordionElementHeaderDirective {

  @HostBinding('class') class = 'card-header p-2';

  constructor() { }

}
